import React from 'react'
import ServiceTxnTableContainer from './ServiceTxnTableContainer'
import { connect } from 'react-redux'
import { fetchCheckedoutServiceTxns } from '../../actions/remote_api'
import storage from '../../storage'
import { transformServiceTxns } from '../../utils/serviceTxn'
import { toastr } from 'react-redux-toastr'

class CheckedoutServiceTxnTableContainer extends React.Component {
  constructor(props) {
    super(props)
    this.isLoading = false
  }

  fetchCheckedoutServiceTxns = (pagination) => {
    toastr.info('Loading')
    this.isLoading = true
    this.props.fetchCheckedoutServiceTxns({
      ...pagination,
      checkedout: true,
      operationDaily: true,
      stationId: storage.info().stationId,
    })
  }

  componentDidUpdate(prevProps) {
    if (
      this.isLoading &&
      prevProps.serviceTxns !== this.props.serviceTxns &&
      this.props.serviceTxns !== undefined
    ) {
      this.isLoading = false
      toastr.success('Load completed')
    }
  }

  settings = {
    selectRow: undefined,
  }

  renderButtonGroup = () => {
    return <div></div>
  }

  render() {
    return (
      <ServiceTxnTableContainer
        {...this.props}
        instances={this.props.serviceTxns}
        fetchInstances={this.fetchCheckedoutServiceTxns}
        actionable={false}
        showCheckoutButton={false}
        showMultiSelect={false}
        btnGroup={this.renderButtonGroup}
        settings={this.settings}
        onDataChange={this.handleDataChange}
        totalCount={this.props.totalCount}
      />
    )
  }
}

export default connect(
  ({ fetch }) => ({
    serviceTxns: fetch.checkedoutServiceTxn
      ? transformServiceTxns(fetch.checkedoutServiceTxn.list)
      : undefined,
    totalCount: fetch.checkedoutServiceTxn
      ? fetch.checkedoutServiceTxn.totalCount
      : undefined,
  }),
  { fetchCheckedoutServiceTxns },
)(CheckedoutServiceTxnTableContainer)
